import { render, staticRenderFns } from "./Товарный отчет за период1.vue?vue&type=template&id=d5b10fa0&scoped=true"
import script from "./Товарный отчет за период1.vue?vue&type=script&lang=js"
export * from "./Товарный отчет за период1.vue?vue&type=script&lang=js"
import style0 from "./Товарный отчет за период1.vue?vue&type=style&index=0&id=d5b10fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b10fa0",
  null
  
)

export default component.exports